import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import commonProps from '../corporate/common/common-props';
import SiteMap from '../corporate/common/site-map';
import Footer from '../corporate/common/footer';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${props => (props.theme.isMobile && `
    width: 100vw;
  `)};
`;

export default function FooterWithSiteMap(props) {
  const common = commonProps();
  const state = {
    ...props,
    ...common,
  };

  return (
    <ThemeProvider theme={state}>
      <Container>
        {
          common.isMobile
            ? <SiteMap slim />
            : (
              <div className="columnar">
                <section className="content">
                  <SiteMap slim />
                </section>
              </div>
            )
        }
        <Footer />
      </Container>
    </ThemeProvider>
  );
}

FooterWithSiteMap.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  sitemapLogo: PropTypes.string.isRequired,
};
